<template>
    <div class="body">
        <el-dialog v-if="space == 11" title="成绩管理（马拉松）" :visible.sync="dialogVisible" append-to-body>
            <div style="display: flex; padding-bottom: 20px;">
                <el-upload ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/act_user_import_marathon" :limit="1" :on-success="onSuccessFile" :data="{ 'token': token, 'data[act_id]': act_id }" name="file" :show-file-list="false">
                    <el-button size="small" type="primary">导入成绩</el-button>
                </el-upload>
                <!-- <el-button size="small" @click="xiazai" style="margin-left: 10px;">导出</el-button> -->
            </div>

            <el-tabs v-model="activeName" type="card">
                <el-tab-pane v-for="tab in tableData" :key="tab.group_id" :label="tab.title" :name="tab.group_id">
                    <vxe-table :data="tab.ranking" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                        <vxe-table-column field="id" title="ID" width="100">
                        </vxe-table-column>
                        <vxe-table-column field="realname" title="姓名" min-width="100">
                        </vxe-table-column>
                        <vxe-table-column field="facepic" title="头像" width="100">
                            <template slot-scope="scope">
                                <img v-if="scope.row.facepic" :src="$ReturnImgUrl(scope.row.facepic)" alt="" style="width: 50px; height: 50px;">
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="act_name" title="活动" min-width="150">
                        </vxe-table-column>
                        <vxe-table-column field="business_name" title="协会" min-width="150">
                        </vxe-table-column>
                        <vxe-table-column field="mobile" title="手机号" width="150">
                        </vxe-table-column>
                        <vxe-table-column field="achievement" title="成绩" width="100">
                        </vxe-table-column>
                        <vxe-table-column field="ranking" title="排名" width="100">
                        </vxe-table-column>
                        <vxe-table-column title="操作" width="100">
                            <template slot-scope="scope">
                                <!-- 修改按钮 -->
                                <el-button type="primary" size="mini" @click="popEdit(scope.row)" icon="el-icon-edit">修改</el-button>
                                <!-- 删除 -->
                                <!-- <el-button type="danger" size="mini" @click="PushDelete(scope.row)" icon="el-icon-delete">删除</el-button> -->
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </el-tab-pane>
            </el-tabs>

            <!-- <vxe-table :data="tableData" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                <vxe-table-column field="id" title="ID" width="100">
                </vxe-table-column>
                <vxe-table-column field="act_name" title="姓名" min-width="100">
                </vxe-table-column>
                <vxe-table-column field="realname" title="实名" min-width="100">
                </vxe-table-column>
                <vxe-table-column field="facepic" title="头像" width="100">
                    <template slot-scope="scope">
                        <img v-if="scope.row.facepic" :src="$ReturnImgUrl(scope.row.facepic)" alt="" style="width: 50px; height: 50px;">
                    </template>
                </vxe-table-column>
                <vxe-table-column field="business_name" title="协会" min-width="150">
                </vxe-table-column>
                <vxe-table-column field="mobile" title="手机号" width="150">
                </vxe-table-column>
                <vxe-table-column field="ranking" title="排名" width="100">
                </vxe-table-column>
                <vxe-table-column title="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="popEdit(scope.row)" icon="el-icon-edit">修改</el-button>
                    </template>
                </vxe-table-column>
            </vxe-table>

            <div v-if="pageshow">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div> -->

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleCloseDialog">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog v-else title="成绩管理（常规）" :visible.sync="dialogVisible" append-to-body>
            <div style="display: flex; padding-bottom: 20px;">
                <el-upload ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/actEnrollImport" :limit="1" :on-success="onSuccessFile" :data="{ token: token, act_id: act_id }" name="file" :show-file-list="false">
                    <el-button size="small" type="primary">导入成绩</el-button>
                </el-upload>
                <el-button size="small" @click="xiazai" style="margin-left: 10px;">导出</el-button>
            </div>

            <el-tabs v-model="activeName" type="card">
                <el-tab-pane v-for="tab in tableData" :key="tab.group_id" :label="tab.title" :name="tab.group_id">
                    <vxe-table :data="tab.ranking" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                        <vxe-table-column field="id" title="ID" width="100">
                        </vxe-table-column>
                        <vxe-table-column field="realname" title="姓名" min-width="100">
                        </vxe-table-column>
                        <vxe-table-column field="facepic" title="头像" width="100">
                            <template slot-scope="scope">
                                <img v-if="scope.row.facepic" :src="$ReturnImgUrl(scope.row.facepic)" alt="" style="width: 50px; height: 50px;">
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="act_name" title="活动" min-width="150">
                        </vxe-table-column>
                        <vxe-table-column field="business_name" title="协会" min-width="150">
                        </vxe-table-column>
                        <vxe-table-column field="mobile" title="手机号" width="150">
                        </vxe-table-column>
                        <vxe-table-column field="achievement" title="成绩" width="100">
                        </vxe-table-column>
                        <vxe-table-column field="ranking" title="排名" width="100">
                        </vxe-table-column>
                        <vxe-table-column title="操作" width="100">
                            <template slot-scope="scope">
                                <!-- 修改按钮 -->
                                <el-button type="primary" size="mini" @click="popEdit(scope.row)" icon="el-icon-edit">修改</el-button>
                                <!-- 删除 -->
                                <!-- <el-button type="danger" size="mini" @click="PushDelete(scope.row)" icon="el-icon-delete">删除</el-button> -->
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </el-tab-pane>
            </el-tabs>

            <!-- <vxe-table :data="tableData" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                <vxe-table-column field="id" title="ID" width="100">
                </vxe-table-column>
                <vxe-table-column field="act_name" title="姓名" min-width="100">
                </vxe-table-column>
                <vxe-table-column field="realname" title="实名" min-width="100">
                </vxe-table-column>
                <vxe-table-column field="facepic" title="头像" width="100">
                    <template slot-scope="scope">
                        <img v-if="scope.row.facepic" :src="$ReturnImgUrl(scope.row.facepic)" alt="" style="width: 50px; height: 50px;">
                    </template>
                </vxe-table-column>
                <vxe-table-column field="business_name" title="协会" min-width="150">
                </vxe-table-column>
                <vxe-table-column field="mobile" title="手机号" width="150">
                </vxe-table-column>
                <vxe-table-column field="ranking" title="排名" width="100">
                </vxe-table-column>
                <vxe-table-column title="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="popEdit(scope.row)" icon="el-icon-edit">修改</el-button>
                    </template>
                </vxe-table-column>
            </vxe-table>

            <div v-if="pageshow">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div> -->

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleCloseDialog">确 定</el-button>
            </span>
        </el-dialog>

        <ChengjiguanliEdit ref="ChengjiguanliEdit" @submit="getList" />
    </div>
</template>

<script>
    import ChengjiguanliEdit from "./ChengjiguanliEdit";

    import { getActRanking, downloadActUserTemp } from '@/api/huodongguanliChengjiguanli'

    export default {
        components: { ChengjiguanliEdit },
        data() {
            return {
                dialogVisible: false,
                act_id: '',
                token: sessionStorage.getItem("token"),

                activeName: '',

                query: {
                    token: sessionStorage.getItem("token"),
                    act_id: '',
                    // page: 1,
                    // pagesize: 10,
                },
                tableData: [],
                pageshow: false,
                total: null,
            }
        },
        created() {},
        methods: {
            handleOpenDialog(row) {
                this.act_id = row.id;
                this.space = row.space;
                this.query.act_id = row.id;
                this.getList();
                this.dialogVisible = true;
            },
            handleCloseDialog() {
                this.dialogVisible = false;
            },

            onSuccessFile(res, file) {
                // 校验结果
                this.$message.success(res.msg);
                this.$refs.upload.clearFiles();
                if (res.result == 1) {
                    this.getList();
                }
            },
            xiazai() {
                window.location.href = `https://ydmxhapi.yundongm.cn:8099/service/admin/actEnrollExport?token=${this.token}&act_id=${this.act_id}&group_id=${this.activeName}`;
            },
            getList() {
                getActRanking(this.query).then(({ data: res }) => {
                    this.tableData = res.data || [];
                    this.total = this.tableData.length;

                    if (this.tableData && this.tableData.length) this.activeName = this.tableData[0].group_id;
                })
            },
            handleSizeChange(val) {
                this.query.pagesize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.page = val;
                this.getList();
            },

            popEdit(row) {
                this.$refs.ChengjiguanliEdit.handleOpenDialog(row);
            },
        }
    }
</script>

<style lang="less" scope>
</style>
